<template>

<el-row :gutter="20">
      <el-col :span="24" :offset="0">
        <div class="grid-content bg-purple">
            <el-form ref="form" :model="form">
              <router-link v-if="form.issub" :to="{name: 'adminsublist', params: {id: this.$route.params.id}}">离开设置</router-link>
              <router-link v-if="!form.issub" :to="{name: 'adminthisdata', params: {id: this.$route.params.id}}">离开设置</router-link>
              <h1>{{form.name}}</h1>
              <h1>奖项设置</h1>
              <el-form-item label="请输入获奖名称">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item >
                <el-checkbox v-model="form.issub">是否有分类</el-checkbox>  {{form.issub}}
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button>取消</el-button>
              </el-form-item>



              <div v-if="form.issub">
                <el-row :gutter="20">
                  <el-col :span="4">添加分类：</el-col>
                  <el-col :span="16">
                    <div class="grid-content bg-purple">
                      <el-input v-model="awardsSub.subname" placeholder="请输入分类名称"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="4">
                      <el-button type="primary" @click="saveSub">添加</el-button></el-col>
                </el-row>
              </div>

              <el-table v-if="form.issub" :data="awardsSubList" border style="width: 100%">
                  <el-table-column type="index" width="80">
                  </el-table-column>
                  <el-table-column label="榜单分类名称">
                      <template scope="scope">
                        <el-input size="small" v-model="scope.row.subname"></el-input>
                      </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="100">
                      <template scope="scope">
                        <el-button type="text" @click="updateSub(scope.row.id, scope.row)" size="small">保存</el-button>
                      </template>
                  </el-table-column>
              </el-table>

            </el-form>
        </div>
      </el-col>
  </el-row>

</template>
<script>
  export default {
  name: 'Setawards',
    data() {
      return {
        form: {
          name: '',
          issub: 0
        },
        awardsSubList: [],
        awardsSub: {
          subname: ''
        }
      }
    },
    mounted: function(){
      var id = this.$route.params.id;
      this.form.id = id;
      this.$nextTick(function () {
          this.$http.get('/api/awards/getawardsdetail',{params : {id: id}}).then(
                response => {
                  console.log(response.body);
                  this.form = response.body.award;
                  if((response.body.list != undefined) && (response.body.list.length > 0)){
                    this.form.issub = 1;
                    this.awardsSubList = response.body.list;
                  }
                },
                response => {
                  console.log('failed');
                }
              );
        });
     },
    watch:{
      form:{
            handler:function(val,oldval){
                if(val.issub){
                  this.form.issub = true;
                }
            },
            deep:true//对象内部的属性监听，也叫深度监听
        }
    },
    methods: {
      onSubmit() {
      console.log(this.form);
        this.$http.post('/api/awards/saveawards', this.form).then(  //保存
          (response) => {
             console.log(response);
             if(response.ok){
              console.log('修改成功');
             }
          },
          (response) => {
             console.log(response);
          }
        )
      },
      saveSub() {
        this.awardsSub.awardId = this.$route.params.id;
        this.$http.post('/api/awards/addawardssub', this.awardsSub).then(   //添加奖项分类
            (response) => {
               console.log(response);
               if(response.ok){
                  console.log('添加成功');
                  this.awardsSub = {};
                  this.awardsSubList.push(response.body.data);
               }
            },
            (response) => {
               console.log(response);
            }
          )
      },
      updateSub(id, v) {
        this.$http.post('/api/awards/addawardssub', v).then(   //添加奖项分类
            (response) => {
               console.log(response);
               if(response.ok){
                  console.log('修改成功');
               }
            },
            (response) => {
               console.log(response);
            }
          )

      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Setawards.vue